import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { injectIntl } from 'react-intl';

import { COLORS } from '../../../constants/styles';
import Checkbox from '../../common/Checkbox';
import styles from '../index.styl';

const labelStyle = {
  color: COLORS.grayDark,
  fontSize: 14,
};

const checkboxStyle = {
  marginBottom: 12,
};

const fieldWrapperStyle = {
  flexDirection: 'column',
  alignItems: 'flex-start',
};

const PrivacySettings = ({ intl: { formatMessage }, onChange, hidden }) => {
  const privacyLabel = (
    <span>
      {formatMessage({ id: 'profile.privacySettings.labels.nickname' })}
      <span styleName="gray-text">
        {formatMessage({ id: 'profile.privacySettings.labels.nicknameExtra' })}
      </span>
    </span>
  );

  return (
    <section styleName="privacy-settings">
      <h3 styleName="sectionTitle">
        {formatMessage({ id: 'profile.section.privacySettings' })}
      </h3>
      <div styleName="fieldWrapper" style={fieldWrapperStyle}>
        <Checkbox
          id="hidden"
          size={14}
          checked={hidden}
          label={privacyLabel}
          labelStyle={labelStyle}
          style={checkboxStyle}
          onChange={onChange}
        />
      </div>
    </section>
  );
};

PrivacySettings.propTypes = {
  onChange: PropTypes.func.isRequired,
  hidden: PropTypes.bool,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
};

export default injectIntl(
  CSSModules(PrivacySettings, styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/PrivacySettings/index.jsx